import { API_BASE_URL } from "./config";

export const getSuppliers = () => {
  return fetch(`${API_BASE_URL}/api/v1/supplier/suppliers`, {
    method: "GET",
  });
};
